/** Facts about the company used in meta tags and structured data. Keep in sync with the footer. */
export const SITE_URL = "https://malilabs.com";
export const SITE_NAME = "MALI Labs";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og-default.png`;
export const LOGO_URL = `${SITE_URL}/images/transparent_logo_small2.png`;

export const ORG = {
  name: "MALI Labs",
  // As registered with APR. The trading name is `name`.
  legalName: "Viktor Čuvik PR MALI Labs",
  taxId: "113475160", // PIB
  registrationNumber: "66851427", // MB, Serbian Business Registers Agency (APR)
  email: "hello@malilabs.com",
  foundingLocation: "Ada, Vojvodina, Serbia",
  address: {
    streetAddress: "Mite Radujkova 12",
    addressLocality: "Ada",
    addressRegion: "Vojvodina",
    postalCode: "24430",
    addressCountry: "RS",
  },
  geo: { latitude: 45.8006, longitude: 20.1281 },
  areaServed: ["Vojvodina", "Serbia", "Hungary", "European Union"],
  // Public profiles (LinkedIn company page, GitHub org, …) - only verified ones.
  sameAs: ["https://www.linkedin.com/company/94792684", "https://github.com/MALILabs"],
  knowsAbout: [
    "Custom software development",
    "Web application development",
    "Artificial intelligence",
    "Large language models",
    "Natural language processing",
    "Intelligent automation",
    "Generative AI pipelines",
    "Systems integration",
    "API architecture",
    "C++ desktop software",
    "Corporate AI training",
    "Progressive web apps",
  ],
  // Canonical spellings for structured data. The on-page names come from
  // about.team.members in the locale files, which may localise the name order.
  founder: "Viktor Csuvik",
  team: [
    { name: "Viktor Csuvik", jobTitle: "Founder and Technology Lead" },
    { name: "Zsolt Vajer", jobTitle: "Software Diagnostics Specialist" },
    { name: "Róbert Simon", jobTitle: "AI and Software Engineer" },
    { name: "Jonathán Borics", jobTitle: "Systems Analyst and Full-Stack Developer" },
  ],
  bookingUrl: "https://calendar.app.google/xRVyBxmDMSGM3fU1A",
};

export const OG_LOCALES = { en: "en_US", hu: "hu_HU", sr: "sr_RS" };

/** Organization + LocalBusiness node, reused on every page via @id */
export const organizationJsonLd = (lang = "en", description) => ({
  "@type": ["Organization", "ProfessionalService"],
  "@id": `${SITE_URL}/#organization`,
  name: ORG.name,
  legalName: ORG.legalName,
  taxID: ORG.taxId,
  identifier: { "@type": "PropertyValue", propertyID: "MB (APR)", value: ORG.registrationNumber },
  url: SITE_URL,
  logo: { "@type": "ImageObject", url: LOGO_URL },
  image: DEFAULT_OG_IMAGE,
  email: ORG.email,
  description,
  inLanguage: lang,
  address: { "@type": "PostalAddress", ...ORG.address },
  geo: { "@type": "GeoCoordinates", ...ORG.geo },
  areaServed: ORG.areaServed.map((name) => ({ "@type": "Place", name })),
  knowsAbout: ORG.knowsAbout,
  knowsLanguage: ["en", "hu", "sr"],
  founder: { "@type": "Person", name: ORG.founder, jobTitle: "Founder and Technology Lead" },
  priceRange: "€€",
  employee: ORG.team.map((p) => ({ "@type": "Person", name: p.name, jobTitle: p.jobTitle, worksFor: { "@id": `${SITE_URL}/#organization` } })),
  contactPoint: [{ "@type": "ContactPoint", contactType: "sales", email: ORG.email, availableLanguage: ["English", "Hungarian", "Serbian"] }],
  ...(ORG.sameAs.length ? { sameAs: ORG.sameAs } : {}),
});

export const websiteJsonLd = (lang = "en") => ({
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: SITE_NAME,
  inLanguage: lang,
  publisher: { "@id": `${SITE_URL}/#organization` },
});
